import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const diyToolBestPicksStylesUS: DomainsBaseStyles = {
  ...defaultStyles,

  COMMONS_APPBAR_BG: 'bg-[#355F9F]',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-[#355F9F]',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#EE995F] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: 'shadow-xl',

  HOMEPAGE_HEADER_BG: 'bg-[#F4F6FA]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#355F9F]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#EE995F] hover:border-[#EE995F] hover:bg-[#EE995F] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#EE995F]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#EE995F]',
  HOMEPAGE_RANK_BANNER_BG: 'bg-[#355F9F]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#355F9F]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#EE995F]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#C27341] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#C27341] text-[#C27341] [&>svg>path]:stroke-[#C27341] [&>svg>g>path]:stroke-[#C27341] [&>svg>path]:fill-[#C27341] [&>svg>g>path]:fill-[#C27341]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#C27341]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#355F9F]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#F4F6FA]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#EE995F]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#F4F6FA]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#355F9F] [&>.explore-icon-fill]:!fill-[#F4F6FA] [&>g>.explore-icon-fill]:!fill-[#F4F6FA]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F4F6FA] [&>.vector-top>path]:fill-[#355F9F] [&>.vector-bottom>path]:fill-[#355F9F]',

  LISTPAGE_USER_VALUE_BADGE: 'text-[#355F9F] [&>div>svg>path]:fill-[#355F9F] bg-[#F4F6FA]',

  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#355F9F]',

  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#EE995F]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-white',

  LISTPAGE_BADGE_WINNER_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#355F9F]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#355F9F]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-[#355F9F]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#355F9F]',

  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#EE995F]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-[#355F9F]',

  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',

  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#355F9F]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#355F9F]',

  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-black',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-black',

  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#030303]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#C27341] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#C27341] text-[#C27341] [&>svg>path]:stroke-[#C27341] [&>svg>g>path]:stroke-[#C27341] [&>svg>path]:fill-[#C27341] [&>svg>g>path]:fill-[#C27341]',
  LISTPAGE_BUTTON_LINK: 'text-[#C27341]',
  LISTPAGE_ANCHOR_LINK: 'text-[#C27341]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#C27341]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#C27341]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#C27341]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#C27341] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#C27341] text-[#C27341]  [&>svg>path]:stroke-[#C27341] [&>svg>g>path]:stroke-[#C27341] [&>svg>path]:fill-[#C27341] [&>svg>g>path]:fill-[#C27341]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#C27341]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#C27341]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#C27341]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#C27341]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#C27341]',

  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F4F6FA] [&>.vector-top>path]:fill-[#355F9F] [&>.vector-bottom>path]:fill-[#355F9F]',

  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#F4F6FA] [&>circle]:stroke-[#F4F6FA] [&>path]:fill-[#355F9F]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#C27341]',

  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:text-black data-[focus]:bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'text-[#C27341] bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#C27341]',
}
